import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import I18nTextField from "../../i18n-text-field";
import {RENDERER_TYPES} from "../constants";
import {isFieldMultilang, pruneEmptyValues} from "../utils";

export const I18nTextFieldTester = schemaMatches(
  schema => schema.renderer === RENDERER_TYPES.i18nTextField || isFieldMultilang(schema)
);

export const I18nTextFieldRenderer = withJsonFormsControlProps(
  ({label, data, handleChange, path, visible, required, errors}) => {
    if (!visible) {
      return null;
    }
    return (
      <I18nTextField
        fullWidth
        label={label}
        required={required}
        error={!!errors}
        helperText={errors}
        variant="outlined"
        value={data}
        onChange={value => handleChange(path, pruneEmptyValues(value))}
        className="custom-json-forms__renderers__i18n-field"
      />
    );
  }
);
